import { createContext, Dispatch, FC, SetStateAction, useContext, useMemo, useState } from 'react';

interface LiveSessionContext {
  liveStatus: LiveStatusType;
  setLiveStatus: Dispatch<SetStateAction<LiveStatusType>>;
}

const LiveSessionContext = createContext<LiveSessionContext | undefined>(undefined);

interface LiveSessionProviderProps {
  session: MorressierSession;
}

export const LiveSessionProvider: FC<LiveSessionProviderProps> = ({ session, children }) => {
  const [liveStatus, setLiveStatus] = useState<LiveStatusType>(session?.main_stage?.live_status);

  const contextValue = useMemo<LiveSessionContext>(
    () => ({
      liveStatus,
      setLiveStatus,
    }),
    [liveStatus],
  );
  return <LiveSessionContext.Provider value={contextValue}>{children}</LiveSessionContext.Provider>;
};

export const useLiveSessionContext = () => {
  const context = useContext(LiveSessionContext);
  if (context === undefined) {
    throw new Error('useLiveSessionContext must be within LiveSessionProvider');
  }

  return context;
};
